export class ApiError extends Error {
  constructor(
    public readonly status: number,
    message: string,
  ) {
    super(message);
    this.name = "ApiError";
  }
}

export class UnauthorizedError extends ApiError {
  constructor() {
    super(401, "Sessão expirada. Entre novamente.");
    this.name = "UnauthorizedError";
  }
}

// 403 nunca revela se o recurso existe — mensagem genérica proposital.
export class ForbiddenError extends ApiError {
  constructor() {
    super(403, "Acesso negado.");
    this.name = "ForbiddenError";
  }
}
